import React from 'react';

import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation, keepPreviousData } from '@tanstack/react-query';

import Table from '../../components/Table';
import TablePageLayout from '../../layouts/TablePageLayout';

import LoanFileService from '../../services/LoanFileService';
import { useUiStore } from '../../store';
import useTableFilters from '../../hooks/useTableFilters';
import useCols from './hooks/useCols';
import useFilters from './hooks/useFilters';

export default function LoanFilesPage() {
  const navigate = useNavigate();

  const cols = useCols();

  const { mutate: deleteLoanFile } = useMutation({
    mutationFn: (id) => LoanFileService.deleteLoanFile(id),
    onSuccess: () => {
      refetch();
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const filters = useFilters('loanFiles');

  const { filtersState, updateFiltersState } = useTableFilters(
    filters,
    'loanFiles'
  );

  const { data: loanFiles, refetch } = useQuery({
    queryKey: [
      'loanFiles',
      ...filtersState['Loan officer'],
      ...filtersState.Status,
      ...filtersState.Team,
      ...(filtersState.Broker ?? []),
    ],
    queryFn: () =>
      LoanFileService.getLoanFiles({
        loanOfficerId: filtersState['Loan officer'],
        status: filtersState.Status,
        teamId: filtersState.Team,
        brokerId: filtersState.Broker,
      }),
    placeholderData: keepPreviousData,
  });

  const showDialogModal = useUiStore((state) => state.showDialogModal);

  const actions = [
    {
      title: 'Edit',
      onClick: (row) => navigate(`/loan-files/${row.id}/details`),
      icon: 'edit',
    },
    {
      title: 'Delete',
      onClick: (row) =>
        showDialogModal({
          title: 'Delete Loan File',
          text: `Are you sure you want to delete loan file ${row.number}?`,
          onConfirm: () => deleteLoanFile(row.id),
        }),
      icon: 'delete',
      danger: true,
    },
  ];

  return (
    <TablePageLayout title="Loan Files">
      <Table
        cols={cols}
        rows={loanFiles}
        countName="Loan Files"
        createButtonLabel="Add Loan File"
        onCreateButtonClick={() => navigate('/loan-files/create/details')}
        actions={actions}
        filters={filters}
        filtersState={filtersState}
        updateFiltersState={updateFiltersState}
      />
    </TablePageLayout>
  );
}
